<template>
  <div class="dashboard-title dashboard-title--basic mb-lg">
    <div class="dashboard-title__actions" style="align-items: flex-start;">
      <div>
        <h1 class="fw-bold fs-xl mb-xs">{{ heading }}</h1>
        <p v-if="paragraph" class="fc-darker fs-md mr-lg">{{ paragraph }}</p>
      </div>
      <slot> </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    heading: String,
    paragraph: String,
  },
};
</script>
